import { useTranslation } from 'react-i18next'

function ReadMore ({ error, helpSearch }) {
  const { t } = useTranslation()
  const search = helpSearch || error
  if (error === 'change-portal-url') {
    return null
  }

  return (
    <span className='text-white cursor-pointer inline-block pt-8'>
      <a className='underline' href={`https://www.geovonic.com/help/?s=${search}`}>
        {t('authPage_readmoreLinkLabel')}
      </a> ...
    </span>
  )
}

export default ReadMore
